import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestore, AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeModule } from './home/home.module';
import { environment } from 'src/environments/environment';
import { PagingModule } from '@pineapplelab/paging';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { GoogleMapsModule } from '@angular/google-maps';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastrModule } from 'ngx-toastr';
import { RecaptchaModule } from 'ng-recaptcha';
import { ProjectService } from './service/project-service/project.service';
import { ThemesService } from './service/theme/theme.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { GetLanguageService } from './service/get-language/get-language.service';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        SharedModule,
        BrowserAnimationsModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFirestoreModule,
        HttpClientModule,
        GoogleMapsModule,
        TranslateModule.forRoot({
            // loader: {
            //   provide: TranslateLoader,
            //   useClass: TranslateService,
            // },
        }),
        MatProgressSpinnerModule,
        ToastrModule.forRoot({
            timeOut: 3000, // Time to close the toaster (in milliseconds)
            positionClass: 'toast-top-right', // Toast position
            closeButton: true, // Show close button
            progressBar: false, // Show progress bar
        }),
        RecaptchaModule,
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled'
          })
    ],
    exports: [MatProgressSpinnerModule],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (themesService: ThemesService) => () => {
                return themesService.loadTheme();
            },
            deps: [ThemesService],
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (themesService: ThemesService) => () => {
                return themesService.loadLogo();
            },
            deps: [ThemesService, ProjectService],
            multi: true,
        },
        TranslateService,
        GetLanguageService,
        {
            provide: APP_INITIALIZER,
            useFactory: (translationService: GetLanguageService)  => () => {
                return translationService.initTranslations();
              },
            deps: [GetLanguageService],
            multi: true
          }

    ],
    bootstrap: [AppComponent],
})
export class AppModule {
    constructor(afs: AngularFirestore) {
        PagingModule.setFirestoreInstance(afs);
    }
}
